module.exports = __webpack_public_path__ + "files/053f0c2d156220454ffd7519e9772ecd.png";